import lodash from "lodash";
import { useState, useCallback } from "react";

export type Dict<A> = Record<string, A>;

export type Setter<A> = (key: string, value: A | undefined) => void;

export default function useDict<A>(
  initial: Dict<A> = {}
): [Dict<A>, Setter<A>] {
  const [values, setValues] = useState<Dict<A>>(initial);

  const setter = useCallback(
    (key: string, newValue: A | undefined) => {
      setValues(values =>
        newValue == null
          ? lodash.omit(values, key)
          : { ...values, [key]: newValue }
      );
    },
    [setValues]
  );

  return [values, setter];
}
